import { useT } from 'hooks';
import { getTransition } from 'styles/useTransition';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';

interface Props {
	backgroundColor?: string;
	backgroundColorDisabled?: string;
	textColor?: string;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
	text?: string;
	fontSize?: number;
	FONT_WEIGHT?: number;
	textTransform?: 'capitalize' | 'uppercase' | 'none' | 'lowercase';
	borderRadius?: number;
	minHeight?: number;
	maxWidth?: number;
	disabled?: boolean;
}

const StyledButton = styled.button<Props>`
	position: relative;
	z-index: 1;
	border: 0;
	min-height: ${({ minHeight }) => minHeight ?? 50}px;
	max-width: ${({ minHeight, theme }) =>
		minHeight ? `${minHeight}px` : theme.contentWidth ? theme.contentWidth : '430px'};
	width: 100%;
	height: 50px;
	white-space: nowrap;
	font-size: ${({ fontSize }) => fontSize ?? 24}px;
	color: ${({ textColor }) => textColor ?? '#fff'};
	font-weight: ${({ FONT_WEIGHT, theme }) => FONT_WEIGHT ?? theme.fontWeight.bold ?? 700};
	border-radius: ${({ borderRadius, theme }) =>
		borderRadius ? `${borderRadius}px` : theme.borderRadius.sm ?? '5px'};
	background: ${({ backgroundColor, theme }) =>
		backgroundColor ??
		theme.colors.primaryGradient1 ??
		'linear-gradient(225deg, #542285 0%, #226 100%)'};
	text-align: center;
	cursor: pointer;
	text-transform: ${({ textTransform }) => textTransform ?? 'none'};
	${({ theme }) => getTransition(theme.durations.ms300, ['opacity', 'background'])};

	${({ disabled }) =>
		disabled
			? css<Props>`
					cursor: not-allowed;
					opacity: 0.8;
					background: ${({ backgroundColorDisabled, theme }) =>
						backgroundColorDisabled ??
						theme.colors.primaryGradient5 ??
						'linear-gradient(225deg, rgba(84, 34, 133, 0.5) 0%, rgba(34, 34, 102, 0.5) 100%)'};
			  `
			: ''}

	&:not(:disabled, :active):hover {
		opacity: 0.9;
	}
`;

export const BrandButton: FC<Props> = props => {
	const { T } = useT();
	const { text = T('continue') } = props;
	return <StyledButton {...props}>{text}</StyledButton>;
};
